import styled from 'styled-components';

import { textStyles as styles } from 'theme';

import { Text } from './Text';

export const StyledRichText = styled(Text)<{
  $requestIsAmp: boolean;
  $simple: boolean;
  $small: boolean;
  $normalize: boolean;
  $textAlignCenter: boolean;
  $noMargin: boolean;
  $color: string | undefined;
}>`
  overflow-wrap: break-word;

  &.idlst-rchtxt {
    /* block-no-empty */
    ${(props) =>
      props.$simple &&
      !props.$requestIsAmp &&
      `
    h1, h2, h3, h4, h5 {
      margin: 1em 0;
      opacity: 0.8;
      font-size: inherit !important;
    }
  `}
    ${(props) =>
      props.$small &&
      !props.$requestIsAmp &&
      `
    ${styles.bodySmall}

    h1, h2, h3, h4 {
      margin: 1em 0;
      ${styles.h4}
    }
  `}
  
  ${(props) =>
      props.$normalize &&
      !props.$requestIsAmp &&
      `
    h1, h2, h3 {
      ${styles.h3}
    }

    h4, h5 {
      font-size: inherit !important;
    }

    h1, h2, h3, h4, h5 {
      margin: 1em 0;
      opacity: 0.8;
    }
  `}
  }

  ${(props) => props.$textAlignCenter && 'text-align: center;'};
  ${(props) => props.$noMargin && 'margin: 0;'};
  ${(props) => props.$color && `color: ${props.$color};`};
`;
